/*
 * Mengen-Auswahl mit Staffelrabatt für die Buchstaben-/Weihnachtstassen (snippets/tassen-set.liquid),
 * abgeleitet von assets/ornamente-set.js (gleicher Ablauf, eigene Namen + automatischer Buchstabe).
 * Tassen mit dem Motiv dieser Seite: Farbe, Name und Buchstabe (bzw. Tier) werden ins teeinblue-Formular
 * gesetzt und dessen "In den Warenkorb" ausgelöst, damit jede Position ihr eigenes teeinblue-Design
 * (Druckdatei) bekommt. Die Vorschau zeigt immer die aktive Tasse.
 * Motiv je Tasse (Alex 14.10.2026): Ab zwei Tassen kann jede Tasse ein anderes Motiv bekommen. Jedes
 * Motiv ist ein eigenes Produkt mit eigener teeinblue-Kampagne. Tassen mit einem anderen Motiv legt das
 * Skript so an wie teeinblue selbst (siehe "Tassen mit anderem Motiv"); die große Vorschau zeigt für sie
 * das Vorschaubild von teeinblue.
 * Farbe: Die Farbwahl von teeinblue oben gilt für alle Tassen; ab zwei Tassen kann jede in ihrer Zeile
 * eine eigene Farbe bekommen (nur Farben, die es beim Motiv der Tasse gibt).
 * Buchstabe: Das teeinblue-Feld mit den 26 Buchstaben ist ausgeblendet, der Buchstabe folgt dem
 * ersten Buchstaben des Namens. Tier-Tasse: Das Tier wählt der Kunde in der Zeile jeder Tasse.
 * Geschenkverpackung: Steht in der Vorlage ein Block "Geschenkverpackung hinzufügen" und ist sein
 * Schalter an, kommt je Tasse eine Verpackung mit in den Warenkorb.
 * Findet das Skript kein teeinblue-Formular, bleibt die Seite unverändert.
 */
(() => {
  const root = document.querySelector('[data-tset]');
  if (!root || root.dataset.tsetInit) return;
  root.dataset.tsetInit = '1';

  // ---------- Einstellungen aus dem Snippet ----------
  let PRICE = parseInt(root.dataset.unitCents, 10) || 0; // Cent
  const TIERS = (root.dataset.tiers || '')
    .split(',')
    .map((p) => p.split(':').map(Number))
    .filter(([n, v]) => n > 0 && v >= 0)
    .sort((a, b) => a[0] - b[0]);
  const FREE = parseInt(root.dataset.free, 10) || 0;
  const SHIP = parseInt(root.dataset.ship, 10) || 0;
  const OPTIONS = (root.dataset.options || '1,2,3,4').split(',').map(Number).filter((n) => n > 0);
  const MAX = Math.max(...OPTIONS);

  const fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  const eur = (cents) => fmt.format(cents / 100);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const el = (tag, cls, text) => {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };
  const plural = (n) => (n === 1 ? '1 Tasse' : `${n} Tassen`);

  async function waitUntil(fn, timeoutMs, step = 120) {
    const t0 = Date.now();
    while (Date.now() - t0 < timeoutMs) {
      try { if (fn()) return true; } catch (e) { /* weiter warten */ }
      await sleep(step);
    }
    return false;
  }

  // ---------- Motive (Kacheln aus snippets/tassen-motiv.liquid) ----------
  // Jedes Motiv ist ein eigenes Produkt. Die Kacheln liefern Name, Produkt-ID, Variante je Farbe, Preis,
  // Kampagnen-Version bei teeinblue, Art (Buchstaben oder Tiere) und das Kachelbild. Kacheln mit
  // data-rabatt="nein" (nicht im Mengenrabatt des Shops) sind nicht je Tasse wählbar und zählen nicht für die Staffel.
  const P = root.dataset.handle; // Motiv dieser Seite
  const MOTIVE = [...document.querySelectorAll('[data-tmotiv] a[data-handle]:not([data-rabatt="nein"])')].map((a) => {
    const img = a.querySelector('img');
    return {
      handle: a.dataset.handle,
      name: a.dataset.name || ((a.querySelector('span') || {}).textContent || '').trim(),
      produktId: a.dataset.productId || '',
      v: a.dataset.teeV || '',
      preis: parseInt(a.dataset.preis, 10) || 0,
      tiere: a.dataset.art === 'tiere',
      bild: (img && img.src) || '',
      varianten: Object.fromEntries((a.dataset.formen || '').split('|').filter(Boolean).map((p) => {
        const k = p.lastIndexOf('=');
        return [p.slice(0, k), p.slice(k + 1)];
      }))
    };
  }).filter((m) => m.handle && m.produktId);
  const motivInfo = (h) => MOTIVE.find((m) => m.handle === h) || null;
  // Motiv je Tasse nur, wenn diese Seite selbst in der Motiv-Auswahl steht
  const MIT_MOTIVEN = MOTIVE.length > 1 && !!motivInfo(P);

  // ---------- Warenkorb ----------
  // Der Mengenrabatt im Shop zählt alle Tassen-Motive zusammen. Liegen schon Tassen im
  // Warenkorb, rechnen Kacheln und Zusammenfassung deshalb mit der Stufe für alle zusammen.
  // gezählt werden die wählbaren Motive und alle Tassen desselben Rabatts (data-rabatt-handles im Snippet)
  const handles = new Set(MOTIVE.map((m) => m.handle));
  (root.dataset.rabattHandles || '').split(',').map((s) => s.trim()).filter(Boolean).forEach((h) => handles.add(h));
  if (P) handles.add(P);
  let imKorb = 0; // Tassen, die schon im Warenkorb liegen
  let korbLeer = true;
  function readCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    imKorb = cart.items.reduce((s, it) => s + (handles.has(it.handle) ? it.quantity : 0), 0);
    korbLeer = !cart.item_count;
    return true;
  }
  const shopRoot = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  async function fetchCart() {
    const r = await fetch(`${shopRoot()}cart.js`, { headers: { Accept: 'application/json' } });
    return r.json();
  }
  async function loadCart() {
    try { readCart(await fetchCart()); } catch (e) { /* ohne Warenkorb-Daten rechnen wir nur mit dieser Auswahl */ }
  }

  // ---------- Geschenkverpackung (Block "ck-ab-gift-wrap" der Vorlage) ----------
  // Der Schalter des Themes legt bei teeinblue-Produkten selbst nichts in den Warenkorb. Das
  // übernimmt hier die Mengen-Auswahl: eine Verpackung je Tasse, im Preis klar ausgewiesen.
  const boxWrap = document.querySelector('.ck-ab-gift-wrap');
  const boxCheck = boxWrap && boxWrap.querySelector('input[type="checkbox"]');
  const BOX_ID = boxWrap ? parseInt(boxWrap.dataset.giftVariant, 10) || 0 : 0;
  const BOX_PRICE = boxWrap ? parseInt(boxWrap.dataset.giftPrice, 10) || 0 : 0;
  const boxAn = () => !!(BOX_ID && boxCheck && boxCheck.checked);
  const boxSumme = (n) => (boxAn() ? BOX_PRICE * n : 0);
  let boxNote = null;
  function renderBoxNote() {
    if (!boxWrap || !BOX_ID) return;
    if (!boxNote) {
      boxNote = el('p', 'tset-boxnote');
      const preis = boxWrap.querySelector('.ck-ab-gift-wrap-price');
      (preis && preis.parentElement ? preis.parentElement : boxWrap).appendChild(boxNote);
    }
    boxNote.hidden = qty < 2;
    boxNote.textContent = `Eine Verpackung je Tasse: ${qty} × ${eur(BOX_PRICE)} = ${eur(BOX_PRICE * qty)}`;
  }
  async function addBoxes(n) {
    const r = await fetch(`${shopRoot()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: BOX_ID, quantity: n }] })
    });
    if (!r.ok) throw new Error('Geschenkverpackung');
  }
  // Warenkorb-Fenster des Themes neu zeichnen (nötig nach dem eigenen Hinzufügen der Verpackung)
  function refreshDrawer(cart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
  }
  // Warenkorb-Fenster neu zeichnen wie nach einem Hinzufügen über teeinblue (assets/teeinblue-custom.js)
  async function warenkorbNeu() {
    try {
      const [cart, teile] = await Promise.all([
        fetchCart(),
        fetch(`${window.location.pathname}?sections=mini-cart`).then((r) => r.json())
      ]);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: { ...teile, ...cart } } }));
    } catch (e) { /* das Fenster zeigt den Stand spätestens beim nächsten Öffnen */ }
  }

  // ---------- teeinblue-Formular ----------
  const scope = () => document.querySelector('form.tee-form-wrapper') || document;
  const tee = {
    textInput: () => scope().querySelector('.tee-field--text input'),
    textField: () => scope().querySelector('.tee-field--text'),
    atc: () => scope().querySelector('.tee-btn--atc'),
    formOption: () => scope().querySelector('.tee-option--color')
  };
  const formRadios = () => { const o = tee.formOption(); return o ? [...o.querySelectorAll('input[type="radio"]')] : []; };
  const formValue = () => (formRadios().find((i) => i.checked) || {}).value || null;

  // ---------- Zustand ----------
  let textTitle = 'Name';
  let maxLen = 20; // teeinblue gibt bei den Tassen keine Grenze vor
  let qty = Math.min(MAX, Math.max(1, parseInt(root.dataset.default, 10) || 1));
  let active = 0;
  let busy = false;
  const namen = Array.from({ length: MAX }, () => '');
  let formen = []; // wählbare Farben dieser Seite (Werte der teeinblue-Farbwahl)
  let basis = null; // Farbe aller Tassen ohne eigene Wahl (= oben gewählte Farbe)
  const eigen = Array.from({ length: MAX }, () => null); // eigene Farbe je Tasse
  const motive = Array.from({ length: MAX }, () => null); // eigenes Motiv je Tasse (null = Motiv dieser Seite)
  const tiere = Array.from({ length: MAX }, () => null); // gewähltes Tier je Tasse (Name der teeinblue-Option)
  // Bei nur einer Tasse gilt das Motiv der Seite (Wahl über die Kacheln oben)
  const motivOf = (i) => (MIT_MOTIVEN && qty > 1 && motive[i]) || P;
  const istFremd = (i) => motivOf(i) !== P;
  let seiteTiere = false; // diese Seite ist die Tier-Tasse (teeinblue-Feld mit Tieren statt Buchstaben)
  const istTierMotiv = (h) => { const m = motivInfo(h); return m ? m.tiere : h === P && seiteTiere; };
  // Farben je Motiv: auf dieser Seite die der teeinblue-Farbwahl, sonst die aus der Kachel
  const farbenVon = (h) => (h === P ? formen : Object.keys((motivInfo(h) || {}).varianten || {}));
  function farbeOf(i) {
    const fs = farbenVon(motivOf(i));
    const w = eigen[i] || basis;
    if (fs.includes(w)) return w;
    if (fs.includes(basis)) return basis;
    return fs[0] || null;
  }
  // Preis je Tasse: Motiv dieser Seite = Preis der gewählten Variante, andere Motive = Preis aus der Kachel
  const preisOf = (i) => (istFremd(i) && (motivInfo(motivOf(i)) || {}).preis) || PRICE;

  // für den Motiv-Wechsel (assets/tassen-motiv.js): Anzahl, Namen, Farben, Motive und Tiere wandern mit
  window.tassenSet = {
    zustand: () => ({
      qty,
      namen: namen.slice(0, qty),
      basis,
      formen: eigen.slice(0, qty),
      motive: motive.slice(0, qty),
      tiere: tiere.slice(0, qty),
      aktiv: active
    })
  };

  const pct = (n) => TIERS.reduce((p, [min, v]) => (imKorb + n >= min ? v : p), 0);
  const rabattiert = (cents, n) => Math.round((cents * (100 - pct(n))) / 100);
  const unit = (n) => rabattiert(PRICE, n);
  // n Tassen: die vorhandenen Zeilen mit ihrem Motiv, weitere wie das Motiv dieser Seite
  const listenpreis = (n) => { let s = 0; for (let i = 0; i < n; i++) s += i < qty ? preisOf(i) : PRICE; return s; };
  const total = (n) => { let s = 0; for (let i = 0; i < n; i++) s += rabattiert(i < qty ? preisOf(i) : PRICE, n); return s; };
  const shipFor = (sub) => (FREE && sub >= FREE ? 0 : SHIP);

  // Namen ins teeinblue-Formular schreiben (für Vorschau und Warenkorb)
  function applyToTee(name) {
    const inp = tee.textInput();
    if (!inp || inp.value === name) return;
    inp.value = name;
    inp.dispatchEvent(new Event('input', { bubbles: true }));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // teeinblue übernimmt eine Form nur über den Klick auf deren <label>. Scroll-Position und Fokus
  // bleiben dabei, wo sie waren. progKlick: unser Klick, nicht der des Kunden (siehe Start).
  let progKlick = false;
  // Fokus nach unserem Klick zurückgeben; fokusZurueck verhindert, dass das Namensfeld dabei die
  // aktive Tasse umstellt (sonst springt die Vorschau auf die Tasse, deren Feld zuletzt Fokus hatte)
  let fokusZurueck = false;
  function fokusWieder(prev) {
    if (!prev || prev === document.activeElement || typeof prev.focus !== 'function') return;
    fokusZurueck = true;
    try { prev.focus({ preventScroll: true }); } finally { fokusZurueck = false; }
  }
  function klickForm(form) {
    if (!form || formValue() === form) return false;
    const input = formRadios().find((i) => i.value === form);
    if (!input) return false;
    const label = (input.id && tee.formOption().querySelector(`label[for="${CSS.escape(input.id)}"]`)) || input;
    const prev = document.activeElement;
    const x = window.scrollX;
    const y = window.scrollY;
    progKlick = true;
    try { label.click(); } finally { progKlick = false; }
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
    fokusWieder(prev);
    return true;
  }
  // Nach einem Formwechsel leert teeinblue gut eine halbe Sekunde später die Eingaben und meldet
  // das als "customization-changed". Erst danach bleibt ein gesetzter Name stehen.
  function nextCustomization(timeoutMs) {
    return new Promise((resolve) => {
      let done = false;
      const finish = (v) => {
        if (done) return;
        done = true;
        document.removeEventListener('teeinblue-event-customization-changed', on);
        resolve(v);
      };
      const on = () => finish(true);
      document.addEventListener('teeinblue-event-customization-changed', on);
      setTimeout(() => finish(false), timeoutMs);
    });
  }
  // teeinblue auf eine Tasse stellen: erst die Farbe, dann Name und Buchstabe bzw. Tier
  async function stelleEin(form, name, wartenMs, tier) {
    if (form && formValue() !== form && formRadios().some((i) => i.value === form)) {
      // mit Text im Feld löst das Leeren nach dem Wechsel sicher die Meldung aus
      if (name) { applyToTee(name); await sleep(40); }
      const geleert = nextCustomization(wartenMs);
      if (klickForm(form)) {
        // Bei den Tassen teilen sich alle Farben ein Design: teeinblue leert hier nichts (anders als bei
        // den Ornament-Formen). Deshalb nicht die volle Zeit auf die Meldung warten.
        await Promise.race([geleert, sleep(900)]);
        await waitUntil(() => formValue() === form && tee.textInput(), 4000, 60);
      }
    }
    applyToTee(name);
    setzeClip(name, tier);
  }
  // ---------- Buchstabe automatisch aus dem Namen, Tier je Tasse ----------
  // Die Buchstaben-Tassen haben ein teeinblue-Feld mit 26 Buchstaben (A–Z bzw. a–z). Der Kunde wählt
  // dort nicht mehr selbst: Es folgt dem ersten Buchstaben des Namens (Umlaute → Grundbuchstabe).
  // Bei der Tier-Tasse steht im selben Feld die Tier-Auswahl; sie wird je Tasse in deren Zeile gewählt.
  const UMLAUT = {
    'Ä': 'A', 'Á': 'A', 'À': 'A', 'Â': 'A', 'Å': 'A', 'Ç': 'C', 'Ć': 'C', 'Č': 'C', 'É': 'E', 'È': 'E', 'Ê': 'E',
    'Í': 'I', 'Ì': 'I', 'Ł': 'L', 'Ń': 'N', 'Ö': 'O', 'Ó': 'O', 'Ò': 'O', 'Ô': 'O', 'Ř': 'R', 'Ś': 'S', 'Š': 'S',
    'Ü': 'U', 'Ú': 'U', 'Ù': 'U', 'Ý': 'Y', 'Ž': 'Z', 'Ź': 'Z', 'Ż': 'Z'
  };
  const anfang = (name) => {
    const c = String(name || '').trim().charAt(0).toUpperCase();
    return c ? UMLAUT[c] || c : null;
  };
  const clipField = () => scope().querySelector('.tee-field--clipart');
  const clipRadios = () => { const f = clipField(); return f ? [...f.querySelectorAll('input[type="radio"]')] : []; };
  const clipLabel = (r) => { const img = (r.closest('.tee-clipart') || r.parentElement).querySelector('img'); return ((img && img.alt) || '').trim(); };
  let istBuchstaben = false;
  function buchstabeFuer(name) {
    const l = anfang(name);
    if (!l) return null;
    return clipRadios().find((r) => clipLabel(r).toUpperCase() === l) || null;
  }
  function clipFuer(name, tier) {
    if (istBuchstaben) return buchstabeFuer(name);
    if (seiteTiere && tier) return clipRadios().find((r) => clipLabel(r) === tier) || null;
    return null;
  }
  // teeinblue übernimmt ein Motiv nur über den Klick auf dessen <label> (siehe servietten-set.js)
  function setzeClip(name, tier) {
    const radio = clipFuer(name, tier);
    const f = clipField();
    if (!radio || !f) return;
    if (radio.checked && !f.classList.contains('tee-field--invalid')) return;
    const label = (radio.id && f.querySelector(`label[for="${CSS.escape(radio.id)}"]`)) || (radio.closest('.tee-clipart') || radio.parentElement).querySelector('label') || radio;
    const prev = document.activeElement;
    const x = window.scrollX;
    const y = window.scrollY;
    progKlick = true;
    try { label.click(); } finally { progKlick = false; }
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
    fokusWieder(prev);
  }
  const clipSteht = (name, tier) => {
    if (istBuchstaben) return !!(buchstabeFuer(name) || {}).checked;
    if (seiteTiere && tier) return !!(clipFuer(name, tier) || {}).checked;
    return true;
  };

  // ---------- Tassen mit anderem Motiv: so anlegen wie teeinblue selbst ----------
  // Ablauf wie beim teeinblue-Formular (Mitschnitt 14.10.2026, Desktop\Code\tassen-buchstaben\motiv-je-tasse):
  // 1) Personalisierung bei teeinblue speichern (POST …/shopify/customization), 2) Posten mit denselben
  // Angaben in den Warenkorb, 3) Personalisierung mit dem Warenkorb verknüpfen (PUT …/cart-token).
  // Die Daten kommen aus der öffentlichen Kampagne des Motivs, die teeinblue auf jeder Produktseite
  // genauso lädt. Passt eine Kampagne oder eine teeinblue-Einstellung nicht zu diesem einfachen Aufbau
  // (ein Design, ein Namensfeld, höchstens ein Bildfeld, keine Design-Links in den Angaben), wird
  // nichts angelegt und der Kunde bekommt einen Hinweis (dann das Motiv auf seiner eigenen Seite wählen).
  const TEE_API = 'https://api.teeinblue.com/api/merchant';
  const TEE_CDN = 'https://cdn.teeinblue.com';
  const SHOP = (window.Shopify && window.Shopify.shop) || 'aldd-marketing.myshopify.com';
  const teeCfg = () => (window.teeinblueCampaign && window.teeinblueCampaign.config) || null;
  const teeOpt = () => window.teeinblue || window.TeeInBlue || {};
  function pruefeEinstellungen() {
    const cfg = teeCfg();
    const links = cfg && cfg.add_design_links;
    if (!cfg || !links || ['property', 'both'].includes(links) || cfg.is_display_customization_edit_link === true ||
      typeof teeOpt().transformBeforeAddToCart === 'function') throw new Error('teeinblue-Einstellungen');
    return cfg;
  }

  const kampagnen = {}; // Handle → Promise der gelesenen Kampagne
  const geladen = {}; // Handle → gelesene Kampagne (sobald da)
  function kampagne(h) {
    const m = motivInfo(h);
    if (!m) return Promise.reject(new Error('Motiv unbekannt'));
    if (!kampagnen[h]) {
      kampagnen[h] = fetch(`${TEE_API}/campaigns/${m.produktId}.json?shop=${encodeURIComponent(SHOP)}${m.v ? `&v=${encodeURIComponent(m.v)}` : ''}`)
        .then((r) => { if (!r.ok) throw new Error(`Kampagne ${r.status}`); return r.json(); })
        .then((k) => { const kk = lies(k); geladen[h] = kk; return kk; })
        .catch((e) => { delete kampagnen[h]; throw e; });
    }
    return kampagnen[h];
  }
  function lies(k) {
    const art = k && Array.isArray(k.artworks) && k.artworks.length === 1 ? k.artworks[0] : null;
    const tpl = art && Array.isArray(art.data) && art.data.length === 1 ? art.data[0] : null;
    const cp = k && Array.isArray(k.campaign_products) && k.campaign_products.length === 1 ? k.campaign_products[0] : null;
    if (!tpl || !cp || (k.global_options || []).length || (art.global_options || []).length) throw new Error('Aufbau');
    // Eingabefelder wie im teeinblue-Formular (verknüpfte Kopien und unsichtbare Ebenen zählen nicht)
    const felder = (tpl.layers || []).filter((l) => l.form_type && l.form_type !== 'linked' && l.visible !== false);
    const text = felder.filter((l) => l.form_type === 'text');
    const clip = felder.filter((l) => l.form_type === 'clipart');
    if (text.length !== 1 || clip.length > 1 || felder.length !== text.length + clip.length) throw new Error('Felder');
    if (felder.some((l) => Object.keys(l).some((key) => /fulfil/i.test(key)))) throw new Error('Felder');
    const kat = clip[0] ? (k.clipart_categories || []).find((c) => c.id === clip[0].clipart) : null;
    if (clip[0] && !(kat && Array.isArray(kat.options) && kat.options.length)) throw new Error('Bilder');
    // Reihenfolge der Felder wie im Formular (Positionen der Vorlage) – so stehen sie auch im Warenkorb
    const ebene = Object.fromEntries((tpl.layers || []).map((l) => [l.id, l]));
    const reihe = (tpl.positions || []).map((id) => ebene[id]).filter((l) => l && felder.includes(l));
    felder.forEach((l) => { if (!reihe.includes(l)) reihe.push(l); });
    // Shopify-Variante → teeinblue-Variante → deren Lager-Kennung (_tib_fulfilled_sku)
    const tv = Object.fromEntries((k.instance_variants || []).map((x) => [String(x.platform_linked_id), x.variant_id]));
    const sku = {};
    (cp.campaign_variants || []).forEach((x) => { if (x.variant && x.variant.fulfillment_linked_id) sku[x.variant_id] = x.variant.fulfillment_linked_id; });
    const optionen = kat ? kat.options.map((o) => ({ name: String(o.name || '').trim(), url: o.url, bild: `${TEE_CDN}/${o.thumbnail || o.url}` })) : [];
    return {
      art,
      tpl,
      text: text[0],
      clip: clip[0] || null,
      reihe,
      optionen,
      buchstaben: optionen.length >= 20 && optionen.every((o) => /^[a-z]$/i.test(o.name)),
      skuAn: !!k.sku_enabled,
      skuFuer: (vid) => sku[tv[String(vid)]] || null
    };
  }
  // Bild-Option einer Tasse: bei Buchstaben-Motiven der erste Buchstabe des Namens, sonst das gewählte Tier
  function optionFuer(kk, name, tier) {
    if (!kk.clip) return null;
    if (kk.buchstaben) {
      const l = anfang(name);
      return (l && kk.optionen.find((o) => o.name.toUpperCase() === l)) || null;
    }
    return kk.optionen.find((o) => o.name === tier) || kk.optionen[0];
  }
  // Daten wie das teeinblue-Formular: Vorlage, Felder in Formular-Reihenfolge, Design-Version, Variante
  function teeDaten(kk, vid, name, opt) {
    const data = { [kk.art.id]: kk.tpl.id };
    kk.reihe.forEach((l) => { data[l.id] = l === kk.text ? name : opt.url; });
    data[`artwork-${kk.art.id}`] = kk.art.current_version_id;
    data.platform_linked_id = String(vid);
    return data;
  }
  // Angaben am Warenkorb-Posten wie bei teeinblue (createLineItemProps im teeinblue-Skript)
  function teeAngaben(kk, id, vid, name, opt) {
    const cfg = pruefeEinstellungen();
    const p = {};
    kk.reihe.forEach((l) => {
      if (!l.show_in_cart) return;
      p[String(l.form_label || l.name || '').trim()] = l === kk.text ? name : opt.name;
    });
    p._customization_id = id;
    const sku = kk.skuFuer(vid);
    if (sku && (cfg.sku_enabled !== undefined ? cfg.sku_enabled : kk.skuAn)) p._tib_fulfilled_sku = sku;
    if (cfg.support_public_property !== false) p.customization_id = id;
    if (cfg.is_display_customization_link || cfg.is_display_customization_link === undefined) p._customization_image = `${TEE_CDN}/customizations/${id}.jpg`;
    return p;
  }
  // Personalisierung speichern; gleiche Tasse (Motiv, Farbe, Name, Bild) wird nur einmal angelegt,
  // z. B. erst für die Vorschau und dann für den Warenkorb. frisch: immer neu (zweite gleiche Tasse)
  const angelegt = new Map();
  async function anlegen(h, farbe, name, tier, frisch) {
    const m = motivInfo(h);
    const kk = await kampagne(h);
    pruefeEinstellungen();
    const vid = m.varianten[farbe];
    if (!vid) throw new Error('Farbe');
    const opt = optionFuer(kk, name, tier);
    if (kk.clip && !opt) throw new Error('Buchstabe');
    const key = [h, vid, name, opt ? opt.url : ''].join('|');
    if (frisch || !angelegt.has(key)) {
      const p = (async () => {
        const r = await fetch(`${TEE_API}/shopify/customization?shop=${encodeURIComponent(SHOP)}&id=${m.produktId}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ data: teeDaten(kk, vid, name, opt), platform_variant_id: String(vid) })
        });
        const j = r.ok ? await r.json() : null;
        if (!j || !j.id) throw new Error('teeinblue');
        return { id: j.id, vid, angaben: teeAngaben(kk, j.id, vid, name, opt) };
      })();
      if (frisch) return p;
      angelegt.set(key, p);
      p.catch(() => angelegt.delete(key));
    }
    return angelegt.get(key);
  }
  async function fremdeInDenWarenkorb(liste) {
    const benutzt = new Set();
    const fertig = [];
    for (const o of liste) {
      let f = await anlegen(o.motiv, o.form, o.name, o.tier);
      // zwei gleiche Tassen: eigene Personalisierung je Posten, wie bei teeinblue
      if (benutzt.has(f.id)) f = await anlegen(o.motiv, o.form, o.name, o.tier, true);
      benutzt.add(f.id);
      fertig.push(f);
    }
    const body = JSON.stringify({ items: fertig.map((f) => ({ id: Number(f.vid), quantity: 1, properties: f.angaben })) });
    let r = null;
    // Shopify bremst bei sehr vielen Anfragen kurz (429): dann etwas warten und noch einmal versuchen
    for (let versuch = 1; versuch <= 3; versuch++) {
      r = await fetch(`${shopRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body
      });
      if (r.status !== 429) break;
      await sleep(1500 * versuch);
    }
    if (!r || !r.ok) throw new Error('Warenkorb');
    // wie teeinblue: Personalisierung mit dem Warenkorb verknüpfen (ohne Verknüpfung bleibt der Posten trotzdem gültig)
    if (teeOpt().store_cart_token !== false) {
      try {
        const token = String((await fetchCart()).token || '').replace(/\?key=.*/, '');
        if (token) {
          await Promise.all(fertig.map((f) => fetch(`${TEE_API}/shopify/customization/${f.id}/cart-token?shop=${encodeURIComponent(SHOP)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cart_token: token })
          }).catch(() => null)));
        }
      } catch (e) { /* siehe oben */ }
    }
    return fertig.length;
  }

  // ---------- Tier-Auswahl (Liste aus der teeinblue-Kampagne der Tier-Tasse) ----------
  const TIER_MOTIV = (MOTIVE.find((m) => m.tiere) || {}).handle || null;
  let tierListe = null; // [{ name, url, bild }]
  let tiereLaden = false;
  function ladeTiere() {
    if (!TIER_MOTIV || tierListe || tiereLaden) return;
    tiereLaden = true;
    kampagne(TIER_MOTIV).then((kk) => {
      tierListe = kk.optionen;
      for (let i = 0; i < qty; i++) fuelleZeile(i);
      if (istTierMotiv(motivOf(active))) syncPreview();
    }).catch(() => { tiereLaden = false; /* ohne Liste bleibt es beim ersten Tier */ });
  }
  const tierOf = (i) => tiere[i] || (tierListe && tierListe[0] ? tierListe[0].name : null);

  // Aufrufe nacheinander abarbeiten, damit sich Formwechsel nicht überholen
  let kette = Promise.resolve();
  const nacheinander = (fn) => { kette = kette.then(fn, fn); return kette; };
  let syncT = null;
  function syncPreview() {
    clearTimeout(syncT);
    syncT = setTimeout(() => {
      if (busy) return;
      if (istFremd(active)) { zeigeFremd(active); return; }
      versteckeVorschau();
      nacheinander(() => (busy ? null : stelleEin(farbeOf(active), namen[active].trim(), 1500, tierOf(active))));
    }, 150);
  }

  // ---------- Vorschau für Tassen mit anderem Motiv ----------
  // Liegt über der Bildergalerie: das Vorschaubild, das teeinblue nach dem Speichern berechnet (mit
  // dessen Wasserzeichen). Ohne Namen zeigt sie das Kachelbild des Motivs.
  let vorschau = null;
  let vorschauNr = 0;
  function vorschauBox() {
    if (vorschau) return vorschau;
    const host = document.querySelector('product-media.product__media') || document.querySelector('.tee-gallery-wrapper');
    if (!host) return null;
    const box = el('div', 'tset-vorschau');
    box.hidden = true;
    const img = el('img', 'tset-vorschau__img');
    img.alt = '';
    const load = el('div', 'tset-vorschau__load');
    load.append(el('span', 'tset-spin'), el('span', null, 'Vorschau wird erstellt …'));
    const cap = el('div', 'tset-vorschau__cap');
    const zu = el('button', 'tset-vorschau__zu', '×');
    zu.type = 'button';
    zu.setAttribute('aria-label', 'Vorschau schließen');
    zu.addEventListener('click', () => { vorschauNr++; box.hidden = true; });
    box.append(img, load, cap, zu);
    host.appendChild(box);
    vorschau = { host, box, img, load, cap };
    return vorschau;
  }
  function versteckeVorschau() {
    vorschauNr++;
    if (vorschau) vorschau.box.hidden = true;
  }
  // teeinblue rechnet das Bild nach dem Speichern noch (ca. 2–3 s): so lange nachfragen
  function bildDa(url, abbruch) {
    return new Promise((resolve) => {
      let n = 0;
      const probe = () => {
        if (abbruch()) { resolve(null); return; }
        const i = new Image();
        i.onload = () => resolve(i.src);
        i.onerror = () => { if (++n >= 40) resolve(null); else setTimeout(probe, 400); };
        i.src = `${url}?v=${n}`;
      };
      probe();
    });
  }
  async function zeigeFremd(i) {
    const v = vorschauBox();
    if (!v) return;
    const nr = ++vorschauNr;
    const h = motivOf(i);
    const m = motivInfo(h);
    const name = namen[i].trim();
    if (getComputedStyle(v.host).position === 'static') v.host.style.position = 'relative';
    const titel = `Tasse ${i + 1} · ${m.name}`;
    v.box.hidden = false;
    if (!name || (!istTierMotiv(h) && !/^[A-Z]$/.test(anfang(name) || ''))) {
      v.img.src = m.bild;
      v.box.classList.add('is-leer');
      v.box.classList.remove('is-loading');
      v.cap.textContent = name ? `${titel}: Der Name muss mit einem Buchstaben beginnen` : `${titel}: Name eintragen für die Vorschau`;
      return;
    }
    v.cap.textContent = `Vorschau ${titel}`;
    v.box.classList.add('is-loading');
    await sleep(450); // Tippen abwarten
    if (nr !== vorschauNr) return;
    try {
      const f = await anlegen(h, farbeOf(i), name, tierOf(i));
      if (nr !== vorschauNr) return;
      const url = await bildDa(`${TEE_CDN}/customizations/${f.id}.jpg`, () => nr !== vorschauNr);
      if (nr !== vorschauNr) return;
      if (!url) throw new Error('Bild');
      v.box.classList.remove('is-leer');
      v.img.src = url;
    } catch (e) {
      if (nr !== vorschauNr) return;
      v.cap.textContent = `${titel}: Vorschau gerade nicht möglich`;
    }
    v.box.classList.remove('is-loading');
  }

  // ---------- Darstellung ----------
  const tilesBox = root.querySelector('[data-tiles]');
  const korbHint = root.querySelector('[data-korb-hint]');
  const namesBox = root.querySelector('[data-names]');
  const namesTitle = root.querySelector('[data-names-title]');
  const namesHint = root.querySelector('[data-names-hint]');
  const bHint = root.querySelector('[data-buchstaben-hint]');
  const summaryBox = root.querySelector('[data-summary]');
  const ctaBtn = root.querySelector('[data-cta]');
  const ctaLabel = root.querySelector('[data-cta-label]');
  const errBox = root.querySelector('[data-err]');

  function renderTiles() {
    tilesBox.textContent = '';
    OPTIONS.forEach((n) => {
      const b = el('button', 'tset__tile' + (n === qty ? ' is-on' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', String(n === qty));
      if (pct(n)) b.appendChild(el('span', 'tset__tag', `−${pct(n)} %`));
      b.appendChild(el('span', 'tset__tile-n', plural(n)));
      b.appendChild(el('span', 'tset__tile-t', eur(total(n))));
      b.appendChild(el('span', 'tset__tile-u', n === 1 && !pct(n) ? 'Einzelpreis' : `je ${eur(unit(n))}`));
      if (korbLeer && FREE && total(n) >= FREE) b.appendChild(el('span', 'tset__tile-ship', 'Versandkostenfrei'));
      b.addEventListener('click', () => setQty(n));
      tilesBox.appendChild(b);
    });
    korbHint.hidden = !imKorb;
    if (imKorb) {
      korbHint.textContent = imKorb === 1
        ? 'Im Warenkorb liegt schon 1 Tasse. Sie zählt für den Mengenrabatt mit.'
        : `Im Warenkorb liegen schon ${imKorb} Tassen. Sie zählen für den Mengenrabatt mit.`;
    }
  }

  function setQty(n) {
    if (busy) return;
    qty = Math.max(1, Math.min(MAX, n));
    if (active >= qty) active = qty - 1;
    errBox.textContent = '';
    renderTiles();
    renderNames();
    renderPrices();
    syncPreview();
  }

  function setActive(i) {
    active = i;
    namesBox.querySelectorAll('.tset__name').forEach((r) => r.classList.toggle('is-active', qty > 1 && Number(r.dataset.i) === i));
    syncPreview();
  }

  // Bild in der Zeile: Buchstabe des Namens im Motiv der Tasse bzw. das gewählte Tier, sonst Kachelbild
  const bildGeholt = {}; // Kampagne für das Zeilenbild nur einmal anfragen
  function bildFuer(i) {
    const h = motivOf(i);
    const kk = geladen[h];
    if (kk) {
      const o = optionFuer(kk, namen[i].trim(), tierOf(i));
      if (o) return o.bild;
    } else if (MIT_MOTIVEN && !bildGeholt[h]) {
      bildGeholt[h] = true;
      kampagne(h).then(() => { for (let n = 0; n < qty; n++) fuelleZeile(n); }).catch(() => { /* Kachelbild bleibt */ });
    }
    return (motivInfo(h) || {}).bild || '';
  }

  function renderNames() {
    namesTitle.textContent = textTitle;
    namesHint.hidden = qty < 2;
    namesBox.textContent = '';
    const beispiel = maxLen >= 30 ? 'z. B. Anna & Markus' : 'z. B. Anna';
    for (let i = 0; i < qty; i++) {
      const row = el('div', 'tset__name' + (qty > 1 && i === active ? ' is-active' : ''));
      row.dataset.i = String(i);
      const inp = el('input');
      inp.id = `tset-name-${i}`;
      inp.type = 'text';
      inp.maxLength = maxLen;
      inp.autocomplete = 'off';
      inp.placeholder = beispiel;
      inp.value = namen[i];
      if (qty > 1) {
        const lab = el('label', null, `Tasse ${i + 1}`);
        lab.htmlFor = inp.id;
        row.appendChild(lab);
        const wahl = el('div', 'tset__wahl' + (MIT_MOTIVEN ? ' mit-motiv' : ''));
        if (MIT_MOTIVEN) {
          const bild = el('img', 'tset__bild');
          bild.alt = '';
          bild.width = 40;
          bild.height = 40;
          const ms = el('select', 'tset__sel tset__motiv');
          ms.setAttribute('aria-label', `Motiv für Tasse ${i + 1}`);
          MOTIVE.forEach((m) => {
            const o = el('option', null, m.name);
            o.value = m.handle;
            ms.appendChild(o);
          });
          ms.addEventListener('change', () => {
            motive[i] = ms.value === P ? null : ms.value;
            if (istTierMotiv(ms.value)) ladeTiere();
            fuelleZeile(i);
            hinweisBuchstabe();
            renderTiles();
            renderPrices();
            if (active !== i) setActive(i); else syncPreview();
          });
          wahl.append(bild, ms);
        }
        const fs = el('select', 'tset__sel tset__form');
        fs.setAttribute('aria-label', `Farbe für Tasse ${i + 1}`);
        fs.addEventListener('change', () => {
          eigen[i] = fs.value;
          if (active !== i) setActive(i); else syncPreview();
        });
        wahl.append(fs);
        row.appendChild(wahl);
      } else {
        inp.setAttribute('aria-label', textTitle);
      }
      const feld = el('div', 'tset__feld');
      const cnt = el('span', 'tset__count', `${namen[i].length}/${maxLen}`);
      inp.addEventListener('input', () => {
        namen[i] = inp.value;
        cnt.textContent = `${inp.value.length}/${maxLen}`;
        row.classList.remove('is-err');
        fuelleZeile(i);
        if (active !== i) setActive(i); else syncPreview();
      });
      inp.addEventListener('focus', () => { if (!fokusZurueck && active !== i) setActive(i); });
      inp.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const next = document.getElementById(`tset-name-${i + 1}`);
        if (next) next.focus(); else ctaBtn.focus();
      });
      feld.append(inp, cnt);
      row.appendChild(feld);
      const tierBox = el('div', 'tset__tiere');
      tierBox.hidden = true;
      row.appendChild(tierBox);
      namesBox.appendChild(row);
      fuelleZeile(i);
    }
    hinweisBuchstabe();
  }
  // Hinweis „Buchstabe folgt dem Namen“ nur, wenn mindestens eine Tasse ein Buchstaben-Motiv hat
  function hinweisBuchstabe() {
    if (!bHint) return;
    let buchstaben = false;
    for (let i = 0; i < qty; i++) if (!istTierMotiv(motivOf(i))) buchstaben = true;
    bHint.hidden = !buchstaben;
  }
  // Zeile nachziehen (Motiv, Farben, Bild, Tier-Auswahl), ohne das Namensfeld neu zu bauen
  function fuelleZeile(i) {
    const row = namesBox.querySelector(`.tset__name[data-i="${i}"]`);
    if (!row) return;
    const h = motivOf(i);
    const ms = row.querySelector('.tset__motiv');
    if (ms && ms.value !== h) ms.value = h;
    const fs = row.querySelector('.tset__form');
    if (fs) {
      const liste = farbenVon(h);
      if (fs.dataset.liste !== liste.join('|')) {
        fs.textContent = '';
        liste.forEach((f) => {
          const o = el('option', null, f);
          o.value = f;
          fs.appendChild(o);
        });
        fs.dataset.liste = liste.join('|');
      }
      fs.value = farbeOf(i);
    }
    const bild = row.querySelector('.tset__bild');
    if (bild) {
      const src = bildFuer(i);
      if (src && bild.getAttribute('src') !== src) bild.src = src;
    }
    const box = row.querySelector('.tset__tiere');
    const zeigen = istTierMotiv(h) && !!(tierListe && tierListe.length);
    box.hidden = !zeigen;
    if (istTierMotiv(h) && !tierListe) ladeTiere();
    if (!zeigen) return;
    if (box.dataset.n !== String(tierListe.length)) {
      box.textContent = '';
      box.appendChild(el('span', 'tset__tiere-h', 'Tier'));
      const grid = el('div', 'tset__tiere-grid');
      tierListe.forEach((o, n) => {
        const b = el('button', 'tset__tier');
        b.type = 'button';
        b.dataset.tier = o.name;
        b.setAttribute('aria-label', `Tier ${n + 1}`);
        const im = el('img');
        im.src = o.bild;
        im.alt = '';
        im.loading = 'lazy';
        b.appendChild(im);
        b.addEventListener('click', () => {
          tiere[i] = o.name;
          fuelleZeile(i);
          if (active !== i) setActive(i); else syncPreview();
        });
        grid.appendChild(b);
      });
      box.appendChild(grid);
      box.dataset.n = String(tierListe.length);
    }
    const wahl = tierOf(i);
    box.querySelectorAll('.tset__tier').forEach((b) => {
      b.classList.toggle('is-on', b.dataset.tier === wahl);
      b.setAttribute('aria-pressed', String(b.dataset.tier === wahl));
    });
  }

  function renderPrices() {
    const sub = total(qty);
    const full = listenpreis(qty);
    summaryBox.textContent = '';
    const row = (a, b, cls) => {
      const r = el('div', 'tset__row' + (cls ? ' ' + cls : ''));
      r.append(el('span', null, a), el('span', null, b));
      summaryBox.appendChild(r);
      return r;
    };
    const gleich = full === PRICE * qty;
    row(gleich ? `${qty} × ${eur(PRICE)}` : plural(qty), eur(full));
    if (pct(qty)) row(`Mengenrabatt (−${pct(qty)} %)`, `−${eur(full - sub)}`, 'is-minus');
    const boxen = boxSumme(qty);
    if (boxen) row(`Geschenkverpackung ${qty} × ${eur(BOX_PRICE)}`, eur(boxen));
    renderBoxNote();
    const summe = sub + boxen;
    if (korbLeer) {
      const ship = shipFor(summe);
      row('Versand', ship ? eur(ship) : 'gratis', ship ? '' : 'is-free');
      if (ship && FREE) {
        summaryBox.appendChild(el('div', 'tset__gap', `Noch ${eur(FREE - summe)} bis zum Gratisversand`));
        const bar = el('div', 'tset__bar');
        const fill = el('i');
        fill.style.width = `${Math.min(100, (summe / FREE) * 100)}%`;
        bar.appendChild(fill);
        summaryBox.appendChild(bar);
      }
      row('Gesamt', eur(summe + ship), 'is-total');
    } else {
      // im Warenkorb liegt schon etwas: Versand hängt vom ganzen Warenkorb ab
      row('Zwischensumme', eur(summe), 'is-total');
      if (FREE) summaryBox.appendChild(el('div', 'tset__gap', `Versand gratis ab ${eur(FREE)} Warenkorbwert`));
    }
    ctaLabel.textContent = `${plural(qty)} in den Warenkorb · ${eur(summe)}`;
    if (stickyLabel) stickyLabel.textContent = plural(qty);
    if (stickyPrice) stickyPrice.textContent = eur(summe);
  }
  const renderAll = () => { renderTiles(); renderNames(); renderPrices(); };

  // ---------- In den Warenkorb ----------
  // Zeitmessung bei Bedarf: in der Browser-Konsole window.TSET_DEBUG = true setzen
  const t0debug = performance.now();
  const dbg = (msg) => { if (window.TSET_DEBUG) console.log(`[tset ${Math.round(performance.now() - t0debug)} ms] ${msg}`); };

  let knownCount = null; // Artikel im Warenkorb, spart eine Abfrage pro Tasse
  const klar = (t) => String(t || '').toLowerCase().replace(/\s+/g, '');
  const artworkShows = (name) => [...document.querySelectorAll('svg.tee-mockup-artwork .tee-layer-text')]
    .some((t) => klar(t.textContent).includes(klar(name)));
  const steht = (o) => (!o.form || formValue() === o.form) && tee.textInput() && tee.textInput().value === o.name && clipSteht(o.name, o.tier);
  async function addViaTee(o) {
    const name = o.name;
    dbg(`Start ${name} (${o.form})`);
    await stelleEin(o.form, name, 2500, o.tier);
    await sleep(150);
    // Form und Name müssen wirklich stehen, sonst noch einmal setzen
    if (!(await waitUntil(() => steht(o), 1500, 60))) {
      dbg('Form/Name stehen noch nicht, setze erneut');
      await stelleEin(o.form, name, 2500, o.tier);
      if (!(await waitUntil(() => steht(o), 3000, 60))) throw new Error('Farbe, Name oder Buchstabe nicht gesetzt');
    }
    await waitUntil(() => artworkShows(name), 3000, 80);
    if (!tee.atc()) throw new Error('kein teeinblue-Button');
    await waitUntil(() => !tee.atc().classList.contains('tee-processing'), 15000, 80);
    if (knownCount == null) knownCount = (await fetchCart()).item_count;
    const before = knownCount;
    dbg('Klick auf teeinblue-Button');
    const ok = await new Promise((resolve) => {
      let settled = false;
      const finish = (v) => {
        if (settled) return;
        settled = true;
        document.removeEventListener('teeinblue-event-after-cart-added', onAdded);
        resolve(v);
      };
      const onAdded = () => { dbg('teeinblue meldet: im Warenkorb'); finish(true); };
      document.addEventListener('teeinblue-event-after-cart-added', onAdded);
      (async () => {
        const t0 = Date.now();
        while (!settled && Date.now() - t0 < 25000) {
          await sleep(600);
          try { if ((await fetchCart()).item_count > before) finish(true); } catch (e) { /* nächster Versuch */ }
        }
        finish(false);
      })();
      tee.atc().click();
    });
    if (!ok) { knownCount = null; throw new Error('Zeitüberschreitung'); }
    knownCount = before + 1;
    // teeinblue verknüpft das Design danach noch mit dem Warenkorb (ca. 0,6 s)
    await sleep(700);
    await waitUntil(() => !tee.atc().classList.contains('tee-processing'), 10000, 80);
    dbg(`Fertig ${name}`);
  }

  function validate() {
    const missing = [];
    for (let i = 0; i < qty; i++) if (!namen[i].trim()) missing.push(i);
    if (!missing.length) {
      // Buchstaben-Motive brauchen einen Namen, der mit einem Buchstaben beginnt
      const ohne = [];
      for (let i = 0; i < qty; i++) {
        if (istTierMotiv(motivOf(i))) continue;
        const ok = istFremd(i) ? /^[A-Z]$/.test(anfang(namen[i]) || '') : (!istBuchstaben || !!buchstabeFuer(namen[i]));
        if (!ok) ohne.push(i);
      }
      if (ohne.length) {
        namesBox.querySelectorAll('.tset__name').forEach((r) => r.classList.toggle('is-err', ohne.includes(Number(r.dataset.i))));
        errBox.textContent = 'Der Name muss mit einem Buchstaben von A bis Z beginnen, sonst gibt es keinen passenden großen Buchstaben.';
        const first = document.getElementById(`tset-name-${ohne[0]}`);
        if (first) first.focus({ preventScroll: true });
        return false;
      }
    }
    namesBox.querySelectorAll('.tset__name').forEach((r) => r.classList.toggle('is-err', missing.includes(Number(r.dataset.i))));
    if (!missing.length) { errBox.textContent = ''; return true; }
    errBox.textContent = qty === 1
      ? 'Bitte trage noch den Namen ein.'
      : missing.length === 1 ? 'Bitte trage noch 1 Namen ein.' : `Bitte trage noch ${missing.length} Namen ein.`;
    const first = document.getElementById(`tset-name-${missing[0]}`);
    if (first) {
      first.scrollIntoView({ block: 'center', behavior: 'smooth' });
      setTimeout(() => first.focus({ preventScroll: true }), 350);
    }
    return false;
  }

  // Fortschrittsfenster
  const modal = el('div', 'tset-modal');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.hidden = true;
  const card = el('div', 'tset-modal__card');
  const mTitle = el('p', 'tset-modal__title');
  const mBar = el('div', 'tset-modal__bar');
  const mFill = el('i');
  mBar.appendChild(mFill);
  const mList = el('ul', 'tset-modal__list');
  card.append(mTitle, el('p', 'tset-modal__sub', 'Einen Moment, wir legen jede Tasse mit ihrem Namen an.'), mBar, mList);
  modal.appendChild(card);
  document.body.appendChild(modal);

  async function addAll() {
    if (busy) return;
    if (!validate()) return;
    busy = true;
    clearTimeout(syncT);
    await kette; // laufenden Vorschau-Wechsel erst zu Ende bringen
    knownCount = null;
    const list = namen.slice(0, qty).map((n, i) => ({ i, name: n.trim(), form: farbeOf(i), motiv: motivOf(i), tier: tierOf(i) }));
    const fremd = list.filter((o) => o.motiv !== P); // andere Motive: direkt bei teeinblue anlegen
    const hier = list.filter((o) => o.motiv === P); // Motiv dieser Seite: über das teeinblue-Formular
    const mitMotiv = new Set(list.map((o) => o.motiv)).size > 1;
    const gemischt = new Set(list.map((o) => o.form)).size > 1;
    mList.textContent = '';
    const items = list.map((o) => {
      const li = el('li');
      const st = el('span', 'tset-modal__st', '·');
      const zusatz = [mitMotiv ? (motivInfo(o.motiv) || {}).name : '', gemischt ? o.form : ''].filter(Boolean).join(', ');
      const text = (list.length > 1 ? `Tasse ${o.i + 1}: ${o.name}` : o.name) + (zusatz ? ` (${zusatz})` : '');
      li.append(el('span', null, text), st);
      mList.appendChild(li);
      return { li, st };
    });
    const mitBox = boxAn();
    let boxItem = null;
    if (mitBox) {
      const li = el('li');
      const st = el('span', 'tset-modal__st', '·');
      li.append(el('span', null, `Geschenkverpackung × ${list.length}`), st);
      mList.appendChild(li);
      boxItem = { li, st };
    }
    // gleiche Farben hintereinander anlegen (jeder Farbwechsel kostet Zeit), mit der gerade gezeigten beginnen
    const jetzt = formValue();
    const rang = (f) => (f === jetzt ? -1 : formen.indexOf(f));
    const folge = hier.slice().sort((a, b) => rang(a.form) - rang(b.form) || a.i - b.i);
    const spin = (o) => { items[o.i].st.textContent = ''; items[o.i].st.appendChild(el('span', 'tset-spin')); };
    const fertig = (o) => { items[o.i].li.classList.add('is-done'); items[o.i].st.textContent = '✓'; };
    mFill.style.width = '0';
    mTitle.textContent = list.length > 1 ? 'Deine Tassen werden erstellt …' : 'Deine Tasse wird erstellt …';
    modal.hidden = false;
    ctaBtn.disabled = true;
    document.documentElement.classList.add('tset-busy');
    let added = 0;
    try {
      if (fremd.length) {
        fremd.forEach(spin);
        dbg(`Andere Motive: ${fremd.length}`);
        await fremdeInDenWarenkorb(fremd);
        fremd.forEach(fertig);
        added += fremd.length;
        mFill.style.width = `${(added / list.length) * 100}%`;
      }
      for (const o of folge) {
        if (list.length > 1) mTitle.textContent = `Tasse ${added + 1} von ${list.length} wird erstellt …`;
        spin(o);
        await addViaTee(o);
        added++;
        fertig(o);
        mFill.style.width = `${(added / list.length) * 100}%`;
      }
      // ohne Tasse über teeinblue zeichnet niemand sonst das Warenkorb-Fenster neu
      if (!folge.length) await warenkorbNeu();
      let boxOk = true;
      if (mitBox) {
        mTitle.textContent = 'Geschenkverpackung wird hinzugefügt …';
        boxItem.st.textContent = '';
        boxItem.st.appendChild(el('span', 'tset-spin'));
        try {
          await addBoxes(added);
          boxItem.li.classList.add('is-done');
          boxItem.st.textContent = '✓';
          refreshDrawer(await fetchCart());
        } catch (e) {
          boxOk = false;
          boxItem.st.textContent = '–';
        }
      }
      mTitle.textContent = 'Fertig!';
      await sleep(500);
      modal.hidden = true;
      if (!boxOk) errBox.textContent = `${added === 1 ? 'Die Tasse liegt' : 'Die Tassen liegen'} im Warenkorb. Die Geschenkverpackung konnte gerade nicht hinzugefügt werden.`;
      const drawer = document.getElementById('mini-cart');
      if (drawer) drawer.open = true;
    } catch (e) {
      dbg(`Fehler: ${e && e.message}`);
      modal.hidden = true;
      errBox.textContent = added
        ? `${plural(added)} ${added === 1 ? 'liegt' : 'liegen'} schon im Warenkorb, die übrigen konnten nicht angelegt werden. Bitte prüfe den Warenkorb und versuche es noch einmal.`
        : list.length > 1
          ? 'Die Tassen konnten gerade nicht angelegt werden. Bitte versuche es noch einmal.'
          : 'Die Tasse konnte gerade nicht angelegt werden. Bitte versuche es noch einmal.';
      if (added) warenkorbNeu();
    } finally {
      busy = false;
      ctaBtn.disabled = false;
      document.documentElement.classList.remove('tset-busy');
      syncPreview(); // Vorschau wieder auf die aktive Tasse
      await loadCart();
      renderTiles();
      renderPrices();
    }
  }

  // ---------- Sticky-Leiste fürs Handy ----------
  let stickyLabel = null;
  let stickyPrice = null;
  function mountSticky() {
    const bar = el('div', 'tset-sticky');
    const txt = el('div', 'tset-sticky__txt');
    stickyLabel = el('span');
    stickyPrice = el('b');
    txt.append(stickyLabel, stickyPrice);
    const b = el('button', 'tset-sticky__btn', 'In den Warenkorb');
    b.type = 'button';
    b.addEventListener('click', addAll);
    bar.append(txt, b);
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-shown', !entry.isIntersecting && entry.boundingClientRect.top > 0);
      });
      io.observe(ctaBtn);
    }
  }

  // für Tests (Desktop\Code\tassen-buchstaben\motiv-je-tasse): Daten und Angaben wie für teeinblue,
  // ohne etwas anzulegen (statt der Personalisierungs-ID steht "ID" in den Angaben)
  window.tassenSet.teeProbe = async (h, farbe, name, tier) => {
    const kk = await kampagne(h);
    const vid = motivInfo(h).varianten[farbe];
    const opt = optionFuer(kk, name, tier);
    return { data: teeDaten(kk, vid, name, opt), angaben: teeAngaben(kk, 'ID', vid, name, opt) };
  };

  // ---------- Start ----------
  ctaBtn.addEventListener('click', addAll);
  if (boxCheck) boxCheck.addEventListener('change', () => { if (!root.hidden) renderPrices(); });
  document.addEventListener('variant:changed', (e) => {
    const v = e.detail && e.detail.variant;
    if (v && typeof v.price === 'number') { PRICE = v.price; renderTiles(); renderPrices(); }
  });
  // Kunde wählt oben eine Farbe: Sie gilt für alle Tassen ohne eigene Wahl und für die aktive.
  // teeinblue leert danach das Textfeld, deshalb den Namen anschließend wieder setzen.
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (progKlick || busy || !t || t.type !== 'radio' || !t.closest || !t.closest('form.tee-form-wrapper .tee-option--color')) return;
    basis = t.value;
    eigen[active] = null;
    for (let i = 0; i < qty; i++) fuelleZeile(i);
    if (istFremd(active)) { syncPreview(); return; }
    nacheinander(async () => {
      await nextCustomization(1500);
      if (!busy && !istFremd(active)) applyToTee(namen[active].trim());
    });
  });
  // Warenkorb an anderer Stelle geändert (z. B. im Warenkorb-Fenster etwas entfernt): Staffel neu rechnen
  ['cart:updated', 'cart:refresh'].forEach((ev) => {
    document.addEventListener(ev, (e) => {
      if (busy) return;
      if (readCart(e.detail && e.detail.cart)) { renderTiles(); renderPrices(); } else loadCart().then(() => { renderTiles(); renderPrices(); });
    });
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) loadCart().then(() => { renderTiles(); renderPrices(); }); });

  (async () => {
    const ready = await waitUntil(() => tee.atc() && tee.textInput(), 20000, 200);
    if (!ready) return; // kein teeinblue → normales Formular bleibt sichtbar
    const h = tee.textField() && tee.textField().querySelector('.tee-field__heading');
    textTitle = (h && h.textContent.replace('*', '').trim()) || textTitle;
    const ml = tee.textInput().maxLength;
    if (ml > 0) maxLen = ml;
    // ohne die Farben, die nicht angeboten werden sollen (data-ohne-formen in snippets/tassen-motiv.liquid)
    const motivBox = document.querySelector('[data-tmotiv]');
    const ohne = ((motivBox && motivBox.dataset.ohneFormen) || '').split(',').map((s) => s.trim()).filter(Boolean);
    formen = formRadios().map((i) => i.value).filter((f) => !ohne.includes(f));
    basis = formen.includes(formValue()) ? formValue() : formen[0] || null;
    // Buchstaben-Tasse (26 Buchstaben im Motiv-Feld) oder Tier-Tasse (Tiere je Tasse in der Zeile)?
    const clips = clipRadios().map(clipLabel);
    istBuchstaben = clips.length >= 20 && clips.every((l) => /^[a-z]$/i.test(l));
    seiteTiere = clips.length > 0 && !istBuchstaben;
    document.documentElement.classList.toggle('tset-buchstaben', istBuchstaben);
    document.documentElement.classList.toggle('tset-tiere', seiteTiere);
    // nach einem Motiv-Wechsel: Anzahl, Namen, eigene Farben, Motive und Tiere übernehmen
    // (Farben nur, wenn es sie beim Motiv der Tasse gibt – das prüft farbeOf)
    const w = window.tassenWechsel;
    if (w) {
      if (w.qty) qty = Math.max(1, Math.min(MAX, Number(w.qty) || 1));
      (w.texte || []).slice(0, MAX).forEach((t, i) => { namen[i] = String(t || '').slice(0, maxLen); });
      (w.formen || []).slice(0, MAX).forEach((f, i) => { eigen[i] = f || null; });
      (w.motive || []).slice(0, MAX).forEach((m, i) => { motive[i] = m && m !== P && motivInfo(m) ? m : null; });
      (w.tiere || []).slice(0, MAX).forEach((t, i) => { tiere[i] = t || null; });
      if (typeof w.aktiv === 'number' && w.aktiv >= 0 && w.aktiv < qty) active = w.aktiv;
    }
    if (namesHint && MIT_MOTIVEN) {
      namesHint.textContent = 'Jede Tasse kann ein eigenes Motiv und eine eigene Farbe bekommen: einfach in ihrer Zeile auswählen. Der Mengenrabatt zählt alle Tassen zusammen.';
    }
    if (seiteTiere) ladeTiere();
    await loadCart();
    // Geschenkverpackung vor Zusammenfassung und Knopf zeigen (der Block der Vorlage steht sonst darunter)
    if (boxWrap && BOX_ID) summaryBox.parentElement.insertBefore(boxWrap, summaryBox);
    document.documentElement.classList.add('tset-on');
    root.hidden = false;
    mountSticky();
    renderAll();
    syncPreview();
  })();
})();
